import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { BridgeMark } from "../components/BridgeMotif";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { t, lang } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const u = await login(email, password, lang);
      const intended = localStorage.getItem("auna_intended_initiative");
      if (u?.role === "admin") navigate("/admin");
      else if (u?.role === "organizer") navigate("/organizador");
      else if (intended && u?.role === "psychologist") navigate(`/iniciativas/${intended}`);
      else navigate("/mi-espacio");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16">
      <BridgeMark size={40} />
      <h1 className="mt-4 font-display text-2xl font-bold tracking-tight text-slateink">{t("auth.login_title")}</h1>
      <form onSubmit={submit} className="mt-8 w-full space-y-4 rounded-2xl border border-border bg-white p-7" data-testid="login-form">
        {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="login-error">{error}</p>}
        <div>
          <Label>{t("common.email")}</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        </div>
        <div>
          <Label>{t("common.password")}</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        </div>
        <Button type="submit" disabled={busy} className="w-full rounded-full bg-terracotta hover:bg-terracotta-hover" data-testid="login-submit">
          {busy ? t("auth.logging_in") : t("auth.login_btn")}
        </Button>
        <div className="text-center">
          <Link to="/recuperar" className="text-sm text-muted-foreground hover:text-terracotta" data-testid="forgot-password-link">{t("auth.forgot")}</Link>
        </div>
      </form>
      <p className="mt-6 text-sm text-muted-foreground">
        {t("auth.no_account")}{" "}
        <Link to="/register" className="font-medium text-terracotta hover:underline" data-testid="go-register">{t("auth.register_here")}</Link>
      </p>
    </div>
  );
}
